import { useMeProfileGetMeProfile } from '@cocoonspace/api'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { ArrowRightIcon } from 'lucide-react'

import { AppWrapper } from '~/components/app-wrapper'
import { MainContainer } from '~/components/atoms/main-container'
import { SectionHeader } from '~/components/atoms/section-header'
import { LocalizedLink as Link } from '~/components/localized-link'
import { BetaBadgeDialog } from './beta-badge-dialog'
import { SchedulingBreadcrumb } from './breadcrumb'
import { EventTypesList } from './event-types-list'
import { ProfileCard } from './profile-card'

export const SchedulingPage = () => {
	const { t } = useLingui()

	const { data: meProfile } = useMeProfileGetMeProfile({
		query: { retry: false },
	})

	const profileSlug = meProfile && 'slug' in meProfile ? meProfile.slug : null

	return (
		<AppWrapper>
			<MainContainer>
				<SchedulingBreadcrumb />

				<div className='flex items-center'>
					<SectionHeader
						title={
							<>
								{t`Prise de rendez-vous`}
								<BetaBadgeDialog />
							</>
						}
						subtitle={t`Créez et partagez votre page de prise de rendez-vous`}
					/>

					{profileSlug && (
						<Button
							variant='textPrimary'
							className='ml-auto'
							asChild
						>
							<Link
								href={`/${profileSlug}`}
								target='_blank'
							>
								{t`Voir ma page`}
								<ArrowRightIcon />
							</Link>
						</Button>
					)}
				</div>

				<ProfileCard />
				<EventTypesList />
			</MainContainer>
		</AppWrapper>
	)
}
